import React, { useEffect, useState } from "react";
import PageHero from "../components/PageHero";
import { ProgramCard } from "../components/Cards";
import { getPrograms } from "../lib/api";

export default function Programs() {
  const [programs, setPrograms] = useState([]);
  const [filter, setFilter] = useState("Tümü");

  useEffect(() => { getPrograms().then(setPrograms).catch(() => {}); }, []);

  const categories = ["Tümü", ...Array.from(new Set(programs.map((p) => p.category).filter(Boolean)))];
  const list = filter === "Tümü" ? programs : programs.filter((p) => p.category === filter);

  return (
    <div>
      <PageHero
        title="Programlarımız"
        subtitle="Haberden spora, kültürden ekonomiye her alanda uzman ekibimizle hazırladığımız programları keşfedin."
        image="https://images.unsplash.com/photo-1742805382153-bb4be26d6031"
      />
      <div className="tv-container py-12">
        <div className="flex flex-wrap gap-2.5 mb-8">
          {categories.map((c) => (
            <button key={c} onClick={() => setFilter(c)}
              className={`rounded-full px-4 py-2 text-sm font-medium transition-all ${
                filter === c
                  ? "bg-gradient-to-r from-[#7c3aed] to-[#a855f7] text-white"
                  : "border border-[var(--tv-border)] text-[var(--tv-muted)] hover:text-white hover:border-[rgba(168,85,247,0.5)]"
              }`}>
              {c}
            </button>
          ))}
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
          {list.map((p, i) => <ProgramCard key={p.id} program={p} index={i} />)}
        </div>
      </div>
    </div>
  );
}
